import { Vector3 } from '@babylonjs/core/Maths/math.vector';
import { Token, TransformFeature } from '@kb3d/models/classes';
import { SubmeshVertexData } from '@kb3d/view/helpers/geometry-helper';
import { FeatureRenderer, SubmeshVertexDataMap } from './feature';
import {
    TransformDependencyData,
    TransformGeometryProcessor,
    TransformWorkerPayload,
} from './geometry-processor/transform-geometry';

export class TransformRenderer extends FeatureRenderer<TransformFeature> {
    modelToken = Token.TransformFeature;
    processor = new TransformGeometryProcessor(this.scene);

    async makeWorkerPayload(feature: TransformFeature, geometryData: SubmeshVertexDataMap) {
        const payload = await super.makeWorkerPayload(feature, geometryData);
        const pivot = feature._parent?.pivot || { x: 0, y: 0, z: 0 };
        const featureData: TransformWorkerPayload = {
            pivot: { x: pivot.x, y: pivot.y, z: pivot.z },
        };

        payload.featureData = featureData;

        return payload;
    }

    updateMeshGeometry(
        feature: TransformFeature,
        vertexData: SubmeshVertexData,
        vertexDataChanges: Partial<SubmeshVertexData>
    ) {
        const meshDynamicId = feature._parent?._dynamicId || '';
        const pivot = feature._parent?.pivot.toVec3() || Vector3.Zero();
        const dependencyData: TransformDependencyData = {
            pivot,
        };
        return this.processor.updateMeshGeometry(feature, vertexData, vertexDataChanges, {
            meshDynamicId,
            data: dependencyData,
        });
    }

    update3dInternal() {}
}
